import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findUnits = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/units${query}`, {
        headers,
    });
};

export const searchUnits = (headers, unsignedName) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/units/search?unsignedName=${unsignedName}`, {
        headers,
    });
};
